var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("v-data-table", {
    staticClass: "elevation-0",
    attrs: {
      "footer-props": _vm.footer,
      headers: _vm.headers,
      items: _vm.items,
      loading: _vm.loading,
      options: _vm.options,
      "server-items-length": _vm.totalItems,
      "item-key": "id",
      sortable: "false",
    },
    on: {
      "update:items": function ($event) {
        _vm.items = $event
      },
      "update:options": function ($event) {
        _vm.options = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "item.created_at",
        fn: function (_ref) {
          var item = _ref.item
          return [
            _c(
              "span",
              {
                staticClass: "d-block mt-1 text-monospace",
                staticStyle: {
                  "font-size": "0.8em",
                  "min-width": "140px",
                },
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.$moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")
                  )
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "v-chip",
              {
                staticClass: "pa-1 mb-1",
                attrs: {
                  pill: "",
                  "x-small": "",
                  color: "light",
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$moment(item.created_at).fromNow()) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
      },
      {
        key: "item.transactionable_type",
        fn: function (_ref2) {
          var item = _ref2.item
          return [
            _c("PointType", {
              attrs: {
                item_type: item.type,
                item_transactionable: item.transactionable_type,
                item_remark: item.remark,
              },
            }),
          ]
        },
      },
      {
        key: "item.amount",
        fn: function (_ref3) {
          var item = _ref3.item
          return [
            item.type.match(/debit/g)
              ? _c(
                  "span",
                  {
                    staticClass:
                      "text-monospace text-right text-success d-block",
                  },
                  [
                    _vm._v(
                      _vm._s(
                        item.amount.toLocaleString("en-US", {
                          maximumFractionDigits: 2,
                          minimumFractionDigits: 2,
                        })
                      )
                    ),
                  ]
                )
              : item.type.match(/credit/g)
              ? _c(
                  "span",
                  {
                    staticClass:
                      "text-monospace text-right text-danger d-block",
                  },
                  [
                    _vm._v(
                      "-" +
                        _vm._s(
                          item.amount.toLocaleString("en-US", {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          })
                        )
                    ),
                  ]
                )
              : _vm._e(),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }